module.exports = __webpack_public_path__ + "img/ETH.1fa49bbb.png";